
<template>
    <v-dialog v-model="dialog" max-width="389" style="right:8%;top:30%;">
      <v-card class="v-card-custom-dialog">
        <v-card-text class="d-flex justify-space-between pt-7 pb-2">
            <div class="d-flex">
                <icon-svg class="mr-2" iconName="dis-change" />
                <span class="contentShow">{{ detail }}</span>
            </div>
            <v-btn small text icon @click="selectClose()">
                <icon-svg class="" iconName="dis-close" />
            </v-btn>
        </v-card-text>
        <v-card-actions class="btn-pos">
          <v-btn class="btn-height-custom btnConfirm" @click="selectConfirm($event)">Confirm</v-btn>
          <v-btn v-if="showCancel" class="btn-height-custom btnCancel" @click="selectClose()">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import IconSvg from "@/vue-caas/components/IconBase.vue";

export default {
    components: {
        IconSvg
    },
    props: {
        detail: {
            default: '',
        },
        showCancel: {
          default: false,
        },
        isCode:{
          default: false,
        },
        color: {
            default: 'validation',
            required: false,
            validator: value => {
              return ['success', 'error', 'warning', 'information', 'validation', 'confirmation', 'alert'].includes(value);
            }
        },
        btnTxt: {
            default: ''
        },
        size: {
          default: 'min'
        }
    },
    data () {
      return {
        dialog: false,
      }
    },
    watch: {
      dialog () {
        this.dialog ? this.$emit('disable-close') : this.$emit('enable-close');
      },
    },
    methods: {
        selectConfirm() {
            this.$emit("select-confirm");
            this.dialog = false;
        },
        selectClose() {
          this.$emit("select-close");
          this.dialog = false;
        }
    }
  }
</script>

<style scoped>
    .btn-pos {
        display: flex;
        justify-content: center;
    }
    .btn-height-custom {
        width: 90px;
        height: 40px !important;
        border-radius: 6px;
    }
    .btnConfirm {
        background-color: #497DDE !important;
    }
    .btnCancel {
        background-color: #A9BECB !important;
    }
    .contentShow {
        color: #000000;
        font-size: 16px;
        font-weight: 600;
    }
</style>